<template>
  <div class="card_offer">
    <img
      class="card_offer__image"
      :src="getImageServer() + location.attributes.image.url"
    >
    <div class="card_offer__actions">
      <v-layout row wrap fill-height>
        <v-flex xs6>
          <div
            class="data_card__buttons--qr"
            style="border-radius: 10px;"
            @click="$emit('select-location', location)">
            <qr-icon></qr-icon>
          </div>
        </v-flex>
        <v-flex xs6 class="actions_buttons">
          <button
            v-if="location.attributes.location_type === 'Paqueteria'"
            class="actions_buttons__delete visible"
            @click="$emit('locker-modal', location)">
            <locker-icon
              :color="hover.edit ? '#FFFFFF' : '#5a6b8e'"
              width="30"
              height="30"
            ></locker-icon>
          </button>
          <button
            v-if="location.attributes.sublocations > 0 && (location.attributes.location_type == 'Llave Permanente' || location.attributes.location_type == 'Reserva General' || location.attributes.location_type == 'Reserva Sublocacion')"
            class="actions_buttons__delete visible"
            title="Editar inmueble"
            @click="$router.push({name: 'edit_sublocation', params: {id: location.id}})"
            @mouseover="hover.sublocation = true"
            @mouseleave="hover.sublocation = false"
            :style="{backgroundColor: hover.sublocation ? '#1476FB' : '#DFE4ED'}">

            <user-property-icon :color="hover.sublocation ? '#FFFFFF' : '#5a6b8e'">
            </user-property-icon>
            <!-- @mouseover="hover.delete = true"
            @mouseleave="hover.delete = false"
            :style="{backgroundColor: hover.delete ? '#FC243B' : '#DFE4ED'}" -->
          </button>
          <button
              class="actions_buttons__edit visible"
              @click="$router.push({name: 'location_edit', params: {id: location.id}})"
              @mouseover="hover.edit = true"
              @mouseleave="hover.edit = false"
              :style="{backgroundColor: hover.edit ? '#1476FB' : '#DFE4ED'}"
            >
              <edit-icon
                :color="hover.edit ? '#FFFFFF' : '#5a6b8e'"
                width="35"
                height="35"
              ></edit-icon>
            </button>
        </v-flex>
      </v-layout>
    </div>

    <div class="card_offer__body">
      <div class="card_offer__body--title">
        {{location.attributes.title | capitalize}}
      </div>

      <div class="card_offer__body--subtitle">
        Descripción
      </div>
      <p class="card_offer__body--text" style="height: 60px">
        {{location.attributes.description}}
      </p>

      <div class="card_offer__body--subtitle">
        Dirección
      </div>
      <p class="card_offer__body--text" style="height: 25px">
        {{location.attributes.address}}
      </p>

      <div class="card_offer__body--subtitle">
        Correo electrónico
      </div>
      <p class="card_offer__body--text" style="height: 25px">
        {{location.attributes.email}}
      </p>

      <div class="card_offer__body--subtitle">
        Tipo de locación
      </div>
      <p class="card_offer__body--text" style="height: 25px">
        {{location.attributes.location_type}}
      </p>

      <div class="card_offer__body--subtitle">
        Ciudad
      </div>
      <p class="card_offer__body--text" style="height: 25px">
        {{location.attributes.city}}
      </p>

    </div>

  </div>

</template>
<script>
export default {
  props: {
    location: Object
  },
  data(){
    return {
      hover: {
        edit: false,
        sublocation: false,
        delete: false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/LocationItem.vue